import * as React from 'react';

import { createIcon } from '../Icon';
export const DollarSignIcon = createIcon(
  <React.Fragment>
    <line x1={12} x2={12} y1={1} y2={23} />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </React.Fragment>,
  'DollarSignIcon'
);
